/**
 * The contract between the password reset email and the reset page:
 * `/reset-password#token=<token>`.
 *
 * The token travels in the fragment, which a browser never sends to a server
 * or in a referrer, and the page drops it from the address as soon as it has
 * read it — the same care the Studio handoff takes with the access token.
 */
export const RESET_TOKEN_PARAM = 'token'

/** The token a reset link carried, or null when the page was opened without one. */
export function readResetToken(hash: string): string | null {
  return new URLSearchParams(hash.replace(/^#/, '')).get(RESET_TOKEN_PARAM) || null
}

/**
 * Drop the fragment from the address bar without navigating, so the token is
 * not left where a copied link, a referrer or a page script could pick it up.
 */
export function forgetResetToken(): void {
  const url = new URL(window.location.href)
  url.hash = ''
  window.history.replaceState(window.history.state, '', url)
}
